import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { em, color, rgba } from '../../../utils/styles'

const TextareaBase = styled.textarea`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin: 0;
  border: 0;
  padding: ${em(6)} 0;
  min-width: 0;
  min-height: 8em;
  flex-grow: 1;
  background: none;
  vertical-align: middle;
  line-height: 1;
  font-size: 1em;
  font-weight: ${theme('fontWeighs.regular')};
  color: ${color('base')};
  white-space: normal;
  resize: vertical;

  &:focus {
    outline: 0;
  }

  &::placeholder {
    color: ${rgba('base', 0.4)};
  }

  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px ${color('white')} inset;
  }
`

export default TextareaBase
